import { mc, StyleProps } from '@styles';
import React, { FC, ReactNode } from 'react';
import IosIcon from './assets/ios.inline.svg';
import AndroidIcon from './assets/android.inline.svg';

interface Props extends StyleProps {
  href?: string;
  target?: string;
  icon?: 'ios' | 'android';
  color?: 'ocean-blue' | 'accent-green';
  children?: ReactNode;
}

export const PostGetTheAppWidgetBtn: FC<Props> = ({
  className,
  href,
  target = '_blank',
  icon,
  color = 'ocean-blue',
  children,
}) => {
  return (
    <a
      className={mc(
        'px-6 py-3 rounded-full inline-block',
        'flex flex-row items-center',
        `bg-${color} hover:bg-accent-orange`,
        'text-sm text-center font-raleway leading-normal font-semibold text-white',
        className,
      )}
      href={href}
      target={target}
    >
      {icon === 'ios' && <IosIcon className="mr-2 relative -top-0.5" width={18} height={22} />}
      {icon === 'android' && <AndroidIcon className="mr-2" width={16} height={19} />}
      <span className="block flex-1">{children}</span>
    </a>
  );
};

export type PostGetTheAppWidgetBtnProps = Props;
export default PostGetTheAppWidgetBtn;
